export const useStyles = (theme) => ({
  root: {
    display: "flex",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  notchedOutline: {},
  labelFocused: { color: "black !important" },
  focused: {
    "& $notchedOutline": {
      borderColor: "black !important",
    },
  },
  paper: {
    paddingTop: 16,
    paddingLeft: 16,
    paddingRight: 16,
    paddingBottom: 24,
    textAlign: "left",
    color: theme.palette.text.secondary,
  },
  gridStyle: {
    cursor: "pointer",
  },
  titleTextStyle: {
    fontSize: 20,
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    color: "#181818",
  },
  textStyle: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  countStyle: {
    fontWeight: "bold",
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    color: "#181818",
  },
  requestTextTitle: {
    fontSize: 20,
    color: "#181818",
  },
  requestCount: {
    fontWeight: "bold",
    fontSize: 20,
    color: "#181818",
  },
  tooltip: { "&:hover": { cursor: "pointer" } },
  body: {
    minHeight: "20vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
});
